module.exports = __webpack_public_path__ + "static/media/RP-B_S_Timeless_Sforza_White.c009bdb3.png";